var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    { staticClass: "bg-white shadow py-5 px-3 mb-4" },
    [
      _c(
        "vs-col",
        { attrs: { "vs-lg": "11" } },
        [
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                { staticClass: "text-center", attrs: { "vs-lg": "1" } },
                [_c("b", [_vm._v("#")])]
              ),
              _c("vs-col", { attrs: { "vs-lg": "2" } }, [
                _c("b", [_vm._v("Tema o materia")])
              ]),
              _c(
                "vs-col",
                { attrs: { "vs-lg": "9" } },
                [
                  _c(
                    "vs-row",
                    [
                      _c("vs-col", { attrs: { "vs-lg": "2" } }, [
                        _c("b", [_vm._v("Tipo de documento")])
                      ]),
                      _c("vs-col", { attrs: { "vs-lg": "2" } }, [
                        _c("b", [_vm._v("Folio")])
                      ]),
                      _c("vs-col", { attrs: { "vs-lg": "3" } }, [
                        _vm.$route.params.view === "salientes"
                          ? _c("b", [_vm._v("Institución de destino")])
                          : _c("b", [_vm._v("Institución remitente")])
                      ]),
                      _c("vs-col", { attrs: { "vs-lg": "3" } }, [
                        _c("b", [_vm._v("Fecha de creación")])
                      ]),
                      _c("vs-col", { attrs: { "vs-lg": "2" } }, [
                        _c("b", [_vm._v("Responsable")])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "vs-col",
        {
          staticClass: "text-center",
          attrs: { "vs-lg": "1", "vs-sm": "4", "vs-xs": "12" }
        },
        [_c("b", [_vm._v("...")])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }